import { IConsentModel } from "./consent.model";

export interface RequestBlueMediaUrl {
  bankId: number;
  consents: IConsentModel[];
  hdim: string | null;
  jsc: string | null;
}

export interface RequestBlueMediaUrlResponse {
  url: string;
}


export interface RequestKontomatikSetSession {
  sessionId: string;
  sessionIdSignature: string;
  bankName: string;
  hdim: string | null;
  jsc: string | null;
}

export interface RequestKontomatikSetSessionResponse {
}

export interface RequestKontomatikSignInRedirectionStart {
  ownerExternalId: string;
  redirectUri: string;
}

export interface RequestKontomatikSignInRedirectionStartResponse {
  redirectionId: string;
  url: string;
}

export enum KontomatikSignInRedirectionStatus {
  Success = 'success',
  Pending = 'pending',
  Error = 'error',
}

export interface RequestKontomatikSignInRedirectionStatusResponse {
  status: KontomatikSignInRedirectionStatus;
  sessionId?: string;
  sessionIdSignature?: string;
  bankName?: string;
}